import React, { memo, useEffect, useRef } from 'react';

interface Props {
  html?: string | null;
  css?: string | null;
  js?: string | null;
  className?: string;
}

export const CodeDemoPreview = memo(({ html, css, js, className }: Props) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (!iframeRef.current) {
      return;
    }

    const iframe = iframeRef.current;
    const doc = iframe.contentDocument;

    if (!doc) {
      return;
    }

    doc.open();
    doc.writeln(`<html lang="en">
    <head>
      <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Lato:400,400i,700&amp;display=swap"></link>
      <link rel="stylesheet" href="/css/demo.css"></link>
      ${css ? `<style>${css}</style>` : ''}
    </head>
    <body>
      ${html ? `<div class="__demo">${html}</div>` : ''}
      ${js ? `<script>;(function(){${js}})();</script>` : ''}
    </body>
</html>`);
    doc.close();
  }, [iframeRef.current, css, html, js]);

  return (
    <iframe
      key={Date.now()}
      ref={iframeRef}
      src="about:blank"
      className={className}
      // allow="midi; geolocation; microphone; camera; display-capture; encrypted-media; clipboard-read; clipboard-write; notifications; payment-handler; persistent-storage; background-sync; ambient-light-sensor; accessibility-events;"
      // sandbox="allow-modals allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation allow-downloads"
      allowFullScreen
    />
  );
});
